import React, { useState, useEffect, useMemo } from 'react';
import { Gauge } from '@ant-design/charts';
import { Loader, Dimmer } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { onError, onWarning } from '../../../components/shared/messages';
import moment from 'moment';
import { GetIncomeReportData } from '../../../api/services/finance';

export const occupancyWidget = ({ HotelIds }) => {
	const [data, setData] = useState();
	const [isLoading, setIsLoading] = useState(false);

	const config = useMemo(() => {
		return {
			autoFit: true,
			percent: data?.OccupancyPercent ? data.OccupancyPercent / 100 : 0.0001,
			range: { color: '#87BD49' },
			renderer: 'svg',
			indicator: {
				pointer: { style: { stroke: '#D0D0D0' } },
				pin: { style: { stroke: '#D0D0D0' } },
			},
			axis: {
				label: {
					formatter: function formatter(v) {
						return Number(v) * 100;
					},
				},
				subTickLine: { count: 3 },
			},
			statistic: {
				title: {
					formatter: function formatter(_ref) {
						var percent = _ref.percent;
						return 'Occupancy: '.concat((percent * 100).toFixed(0), '%');
					},
					offsetY: 0,
					style: {
						color: 'rgba(0,0,0,0.65)',
						fontSize: '1em',
					},
				},
				content: {
					formatter: function formatter() {
						return `Occupied Rooms: ${data?.OccupiedRooms || 0} `;
					},
					offsetY: 25,
					style: {
						color: 'rgba(0,0,0,0.65)',
						fontSize: '1em',
					},
				},
			},
		};
	}, [data]);

	useEffect(() => {
		if (!HotelIds.length) return;

		(async () => {
			try {
				setIsLoading(true);
				const data = await GetIncomeReportData(
					HotelIds.reduce(
						(result, hotelId, idx) => {
							result['SelectedHotelIDs[' + idx + ']'] = hotelId;
							return result;
						},
						{
							StartDate: moment().toISOString(),
							EndDate: moment().toISOString(),
						}
					)
				);
                                const [dataToSave] = data;
                                
				setData({
					OccupancyPercent: dataToSave?.OccupancyPercent,
					OccupiedRooms: dataToSave?.OccupiedRooms,
				});

				setIsLoading(false);
			} catch (error) {
				setIsLoading(false);
				error.status === 400 ? onWarning(error) : onError(error);
			}
		})();
	}, [HotelIds]);

	return (
		<>
			{isLoading ? (
				<Dimmer active inverted>
					<Loader inline='centered' size='medium' />
				</Dimmer>
			) : (
				<Gauge {...config} style={{ height: '100%', marginTop: '-20px' }} />
			)}
		</>
	);
};

occupancyWidget.propTypes = {
	HotelIds: PropTypes.array,
};
